export default __webpack_public_path__ + "static/media/special-cat.27a57134.webp";